var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},_vm._l((_vm.steps),function(label,i){return _c('div',{key:i,staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"step-indicator",class:{
				'step-active':  _vm.currentStep === i + 1,
				'step-done':    _vm.currentStep >  i + 1,
				'step-pending': _vm.currentStep <  i + 1,
			}},[(_vm.currentStep > i + 1)?_c('span',[_vm._v("✓")]):_c('span',[_vm._v(_vm._s(i + 1))])]),_c('span',{staticClass:"ml-2 small",class:{ 'font-weight-bold': _vm.currentStep === i + 1 }},[_vm._v(_vm._s(label))]),(i < _vm.steps.length - 1)?_c('span',{staticClass:"mx-3 text-muted"},[_vm._v("›")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }